import React, { useState } from "react";

/**
 * Reusable, vertically‑scrollable modal built with TailwindCSS.
 *
 * Props (plain JS):
 *  - buttonText (string): label for the trigger button.
 *  - setVisibility (function, optional): called with `true` when the modal opens and `false` when it closes.
 *  - children (ReactNode): any UI content you want to display inside the modal.
 */
function ModalWithCloseButton({ buttonText, children }) {
  const [open, setOpen] = useState(false);

  const openModal = () => {
    setOpen(true);
   // if (setVisibility) setVisibility(true);
  };

  const closeModal = () => {
    setOpen(false);
   // if (setVisibility) setVisibility(false);
  };

  return (
    <>
      {/* Trigger button */}
      <button
        onClick={openModal}
        className="rounded-md bg-teal-600 px-4 py-2 font-medium text-white shadow hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-400"
      >
        {buttonText}
      </button>

      {/* Backdrop & Modal */}
      {open && (
        <div
          className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 backdrop-blur-sm"
          onClick={closeModal}
        >
          {/* Dialog card */}
          <div
            className="relative max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-xl bg-white p-6 shadow-lg"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
          >
            <div>
            {children}
            </div>
            <br /> <br />
            {/* Close button */}
            <button
              onClick={closeModal}
              className="absolute bottom-4 right-4 rounded-full bg-teal-600 px-4 py-2 text-sm font-medium text-white shadow hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-400"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export {ModalWithCloseButton};
